import { CommerceToolsApi } from '@grandvisionhq/commercetools';

const isContactLenses = (productType)=>CommerceToolsApi.isLenses(productType) || CommerceToolsApi.isContactLensBundle(productType)
;
var ProductRecommendationAction;
(function(ProductRecommendationAction) {
    ProductRecommendationAction["AddToCart"] = 'addToCart';
    ProductRecommendationAction["AddQuantity"] = 'addQuantity';
    ProductRecommendationAction["Redirect"] = 'redirect';
})(ProductRecommendationAction || (ProductRecommendationAction = {}));
var BannerRecommendationAction;
(function(BannerRecommendationAction) {
    BannerRecommendationAction["DiscountCode"] = 'discountCode';
    BannerRecommendationAction["Link"] = 'link';
})(BannerRecommendationAction || (BannerRecommendationAction = {}));

export { BannerRecommendationAction, ProductRecommendationAction, isContactLenses };
//# sourceMappingURL=types.js.map
